
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/cuisine/[cuisine]",
      function () {
        return require("private-next-pages/restaurants/cuisine/[cuisine].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/cuisine/[cuisine]"])
      });
    }
  